import React, { useMemo } from 'react'
import { MatchContentWithProvider } from './MatchContent';
import { Icon, Label } from 'semantic-ui-react';
import { getSectionColor } from 'projectSpecific/sports/create/sectionColors';
import { uniqueKey } from 'global/common/keys';
import _ from 'lodash';

const _labelSize = 'tiny'

export const MatchLevelDateSchedule = ({ levelKey, matches, teamKey, matchDisplayType, matchScheduleDisplayType, team_fav_keys }) => {

  // 🧠 Memoize grouped & sorted structure
  const groupedMatches = useMemo(() => {
    if (_.isEmpty(matches)) return [];

    // 1️⃣ Group by section
    const matches_sections = _.groupBy(matches, 'sections');

    // 2️⃣ Sort section keys (put 'non' last)
    const sortedKeys = _.sortBy(Object.keys(matches_sections), (key) =>
      key.toLowerCase() === 'non' ? Infinity : key
    );

    // 3️⃣ Build final div list
    const divs = _.map(sortedKeys, (smKey) => {
      const sectionMatches = matches_sections[smKey];
      const sectionKey = smKey || 'non';
      const parentKey = `${levelKey || 'defaultLevel'}-${sectionKey}`;

      // Sort by home team name
      const sortedMatches = _.sortBy(sectionMatches, ['home.name']);

      const divs_sections = getMatchesDivs(
        sortedMatches,
        matchDisplayType,
        matchScheduleDisplayType,
        parentKey,
        teamKey,
        team_fav_keys
      );

      return {
        key: parentKey,
        sectionKey,
        label: _.startCase(sectionKey),
        matches: divs_sections
      };
    });

    return divs;
  }, [matches, levelKey, teamKey, matchDisplayType, matchScheduleDisplayType, team_fav_keys]);

  // 🏷️ Helpers (can stay outside useMemo)
  const sectionLabel = (section) => (
    <Label circular size={_labelSize} color={getSectionColor(section)} />
  );

  const divider_section = (value, icon, index, sectionKey) => (
    <div className="match-date-sec" key={uniqueKey('mls', 'tm', index, value)}>
      {icon && <Icon name={icon} />}
      <div>{value}</div>
      {sectionKey && sectionLabel(sectionKey)}
    </div>
  );

  // 🧩 Render memoized divs
  const gms = groupedMatches.map(({ key, label, sectionKey, matches }) => (
    <div key={key}>
      {divider_section(label, null, null, sectionKey)}
      {matches}
    </div>
  ));

  return gms

}

export const getMatchesDivs = (matches, matchDisplayType, matchScheduleDisplayType, parentKey, teamKey, teamKeys = []) => {

  let finalMatches = matches;

  if (teamKeys && teamKeys.length > 0) {
    // decorate each match with _favTeamKey if found
    finalMatches = _.map(matches, (match) => {
      const favKey = _.find(teamKeys, (tk) =>
        tk === match?.home?.id || tk === match?.away?.id
      );
      return { ...match, _favTeamKey: favKey || null };
    });

    // prioritize matches with a _favTeamKey
    finalMatches = _.orderBy(finalMatches, (m) => (m._favTeamKey ? 0 : 1), "asc");
  }

  return _.map(finalMatches, (match) => (
    <MatchContentWithProvider
      key={match._itemKey}
      matchKey={match._itemKey}
      match={match}
      matchDisplayType={matchDisplayType}
      parentKey={parentKey}
      teamKey={teamKey}
      matchScheduleDisplayType={matchScheduleDisplayType}
      favTeamKey={match._favTeamKey} // 👈 pass it down if needed
    />
  ));
};

export const DateMatches = ({ matches, matchDisplayType, matchScheduleDisplayType, parentKey, teamKey }) => {

  return _.map(matches, (match) => (
    <MatchContentWithProvider
      key={match._itemKey}
      matchKey={match._itemKey}
      match={match}
      matchDisplayType={matchDisplayType}
      parentKey={parentKey}
      teamKey={teamKey}
      matchScheduleDisplayType={matchScheduleDisplayType}
      favTeamKey={match._favTeamKey} // 👈 pass it down if needed
    />
  ));
}


export const MatchLevelPlayoffDateSchedule = ({ matches_playoffs, teamKey, matchDisplayType, matchScheduleDisplayType, team_fav_keys }) => {
  const _pm = _.sortBy(matches_playoffs, 'matchNumber')
  const divs_sections = getMatchesDivs(_pm, matchDisplayType, matchScheduleDisplayType, 'parentKey', teamKey, team_fav_keys);
  return divs_sections
}